/* Safari 100vh height fix */
const setVh = function() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};
window.addEventListener('load', setVh);
window.addEventListener('resize', setVh);

jQuery(document).ready(function($) {

  /**
   * Preloader
   */
  let stateCheck = setInterval(() => {
    if (document.readyState === 'complete') {
      clearInterval(stateCheck);
      // document ready
      $('body').not('.t-home').removeClass('is-loading');
    }
  }, 100);

	// function addScrollClass() {
	// 	if (window.matchMedia("(min-width: 45em)").matches) {
	// 		var scrollDepth = 460;
	// 	} else {
	// 		var scrollDepth = 180;
	// 	}
	// 	$('body').toggleClass('is-scrolled', $(document).scrollTop() > scrollDepth);
	// }
  var lastScrollTop = 0;
  function addScrollClass() {
    var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (currentScrollTop > lastScrollTop) {
      $('body').addClass('is-scrolled');
    } else {
      $('body').removeClass('is-scrolled').addClass('is-scrolled-back');
    }
    if (currentScrollTop == 0) {
      $('body').removeClass('is-scrolled').removeClass('is-scrolled-back');
    }
    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  }
	document.addEventListener('scroll', addScrollClass, { passive: true });

	$('.js-nav-contact').on('click', function(event) {
		event.preventDefault();
    if (window.matchMedia("(min-width: 64em)").matches) {
      $('body').toggleClass('contact-is-visible');
    } else {
      $('.js-mobile-menu-link').toggleClass('open');
      $('body').toggleClass('mobile-menu-is-visible');
    }
	});
	$('.js-close-contact').on('click', function(event) {
		event.preventDefault();
		$('body').removeClass('contact-is-visible');
	});

	$('.js-nav-directors').on('click', function(event) {
		event.preventDefault();
		$('body').toggleClass('directors-is-visible');
	});
	$('.js-close-directors').on('click', function(event) {
		event.preventDefault();
		$('body').removeClass('directors-is-visible');
	});

	$('.js-mobile-menu-link').on('click', function(event) {
		event.preventDefault();
    $(this).toggleClass('open');
		$('body').toggleClass('mobile-menu-is-visible');
	});

	$('.js-toggle').on('click', function(event) {
		event.preventDefault();
		$('.toggle-content').removeClass('is-visible');
		$(this).next().addClass('is-visible');
	});

  // Play vimeo in pop up if accessed by project's url
  let vimeoID = $('.js-modal-player').data('video-id');
  if ( vimeoID ) {
    let vimeoUrl = 'https://vimeo.com/' + vimeoID;

    if ( typeof vimeoModalPlayer !== 'undefined' ) {
      vimeoModalPlayer.loadVideo(vimeoID).then(function(id) {
      // The new video is loaded
      }).catch(function(error) {
        // console.log(error.name);
      });
    } else {
      var options = {
        url: vimeoUrl,
        width: 800,
        autoplay: true,
        controls: true,
        responsive: false,
        portrait: false,
        title: false,
        byline: false,
        muted: false
      };

      vimeoModalPlayer = new Vimeo.Player('vimeo-modal-player', options);
    }
  }


  // Play vimeo in pop up
  $('body').on('click', '[class*="js-video-overlay"]', function (event) {
    event.preventDefault();

    $('body').toggleClass('player-is-visible');

    $('.js-more-link-director span').html($(this).data('director'));
    $('.js-more-link-director').attr('href', $(this).data('director-link'));

    let vimeoID = $(this).data('video-id');
    let vimeoUrl = 'https://vimeo.com/' + vimeoID;

    let slug = $(this).data('slug');
    if ( typeof slug !== 'undefined' ) {
      let currentUrl = window.location;
      let newUrl = currentUrl.toString().slice(-1) == "/" ? slug : currentUrl.toString() + "/" + slug;
      history.replaceState({}, "", newUrl);
    }

    if ( typeof vimeoModalPlayer !== 'undefined' ) {
      vimeoModalPlayer.loadVideo(vimeoID).then(function(id) {
      // The new video is loaded
      }).catch(function(error) {
        // console.log(error.name);
      });
    } else {
      var options = {
        url: vimeoUrl,
        width: 800,
        autoplay: true,
        controls: true,
        responsive: false,
        portrait: false,
        title: false,
        byline: false,
        muted: false
      };

      vimeoModalPlayer = new Vimeo.Player('vimeo-modal-player', options);
    }
  });

  $('.js-close-player').on('click', function(event) {
    event.preventDefault();
    $('body').removeClass('player-is-visible');
    vimeoModalPlayer.unload().then(function() {
      // The video has been unloaded
      let currentUrl = window.location;
      let newUrl = currentUrl.toString().slice(-1) == "/" ? "../" : "./";
      history.replaceState({}, "", newUrl);
    });
  });

  $('.js-load-more').on('click', function(event) {
    event.preventDefault();
    $(this).parent().remove();
    $('.js-load-more-projects > *').appendTo($('.block-projects'));
  });
});
